import ProductViewsCount from 'components/ProductPage/ProductViewsCount/ProductViewsCount';
import { withProductViewsCountProps } from 'viewModel/productPage/productViewsCount/withProductViewsCountProps';

export default withProductViewsCountProps(ProductViewsCount);
